'use client';

import { createContext } from 'react';
import type { UnifyAppsAnalyticsClient } from './analytics';

export const AnalyticsContext = createContext<UnifyAppsAnalyticsClient | undefined>(undefined);
